<div class="timezone">
  <form>
    <mat-form-field [ngClass]="{ error: !optionOkay }" class="full-width">
      <input type="text"
             placeholder="Time Zone"
             aria-label="Number"
             matInput
             (change)="setTimeZoneDirectly($event)"
             [formControl]="myControl"
             [matAutocomplete]="auto">
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option (onSelectionChange)="setTimezoneByOption(option, $event.isUserInput)" *ngFor="let option of filteredOptions" [value]="option">
          {{option}}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </form>
</div>